import React, { useState } from 'react'
import {
  Box,
  Image,
  Stack,
  Text,
  useMediaQuery,
  VStack
} from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import LogoutHeader from '../../components/LogoutHeader'
const quilmesImages = require.context('../../assets/images', true)

function Home () {
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const { userRegister } = useAuth()

  return (
    <Stack paddingBottom={'2rem'}>
      <Box
        alignItems={'center'}
        className='logo-home'
        display={'flex'}
        justifyContent={'space-around'}
      >
        <LogoutHeader />
      </Box>

      <VStack mx={'auto'} paddingTop={'20px'}>
        <Text
          className='texto-saludo'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
          paddingBottom={'1rem'}
        >
          ¡Hola {userRegister.name} {userRegister.surname}!
        </Text>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/products-management'>
            <Text className='texto-gestion'> Gestión de Productos </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/area-management'>
            <Text className='texto-gestion'>
              {' '}
              Gestión de Áreas geográficas{' '}
            </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/distributor-management'>
            <Text className='texto-gestion'> Gestión de Distribuidores </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/bottler-management'>
            <Text className='texto-gestion'> Gestión de Embotelladoras </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/channel-management'>
            <Text className='texto-gestion'> Gestión de Canales </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/attributes-management'>
            <Text className='texto-gestion'>
              {' '}
              Gestión de Atributos de producto{' '}
            </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
        <Box
          className='gestion-list'
          {...(isLargerThan768 ? { width: '40%' } : { width: '90%' })}
        >
          <Link className='link-gestion' to='/products-area'>
            <Text className='texto-gestion'>
              {' '}
              Productos por área geográfica{' '}
            </Text>
            <Image
              className='img-gestion'
              src={quilmesImages('./flecha.svg')}
              w={'24px'}
            />
          </Link>
        </Box>
      </VStack>
    </Stack>
  )
}

export default Home
